const TwitterIcon = ({ ...props }) => {
  return (
    <svg
      width="45"
      height="44"
      viewBox="0 0 45 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" width="44" height="44" rx="22" fill="#1DA1F2" />
      <g clipPath="url(#clip0_5631_18093)">
        <path
          d="M34.5 14.5585C33.6075 14.95 32.6565 15.2095 31.665 15.3355C32.685 14.7265 33.4635 13.7695 33.8295 12.616C32.8785 13.183 31.8285 13.5835 30.7095 13.807C29.8065 12.8455 28.5195 12.25 27.1155 12.25C24.3915 12.25 22.1985 14.461 22.1985 17.1715C22.1985 17.5615 22.2315 17.9365 22.3125 18.2935C18.222 18.094 14.6025 16.1335 12.171 13.147C11.7465 13.8835 11.4975 14.7265 11.4975 15.634C11.4975 17.338 12.375 18.8485 13.683 19.723C12.8925 19.708 12.117 19.4785 11.46 19.117C11.46 19.132 11.46 19.1515 11.46 19.171C11.46 21.562 13.1655 23.548 15.402 24.0055C15.0015 24.115 14.565 24.1675 14.112 24.1675C13.797 24.1675 13.479 24.1495 13.1805 24.0835C13.818 26.032 15.627 27.4645 17.778 27.511C16.104 28.8205 13.9785 29.6095 11.6775 29.6095C11.274 29.6095 10.887 29.5915 10.5 29.542C12.6795 30.9475 15.2625 31.75 18.048 31.75C27.102 31.75 32.052 24.25 32.052 17.749C32.052 17.5315 32.0445 17.3215 32.034 17.113C33.0105 16.42 33.831 15.5545 34.5 14.5585Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_5631_18093">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(10.5 10)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TwitterIcon;
